import DetailsPayouts from './DetailsPayouts.view';

export default DetailsPayouts;
